import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useChurchesStore } from '../store/churchesStore'
import { addChurch } from '../utils/addChurch'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useAddChurchMutation = (onSuccess?: () => void) => {
  const add = useChurchesStore((state) => state.add)

  return useMutation({
    mutationFn: addChurch,
    onSuccess: ({ message, church }) => {
      add(church)
      toast.success(message || 'Church created successfully.')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(error, 'An error occurred while creating church.')
    },
  })
}
